export default __webpack_public_path__ + "static/Economic Model Update - Japanese-3dc7740a9fa413a6be971ff7c989de49.pdf";